// The URL state of the audit log (`/settings/audit?…`): the route validates it with this schema and the
// page edits it, so a filter that was shared or reloaded is checked exactly once, here.
import { z } from 'zod';

export const AUDIT_WHEN = ['24h', '7d', '30d', '90d', 'all'] as const;
export type AuditWhen = (typeof AUDIT_WHEN)[number];

export const AuditSearch = z.object({
  event: z.string().max(64).optional(),
  q: z.string().max(200).optional(),
  actor: z.string().max(300).optional(),
  cat: z.string().max(40).optional(),
  object: z.string().max(63).optional(),
  when: z.enum(AUDIT_WHEN).optional(),
  cx: z.uuid().optional(),
});
export type AuditSearch = z.infer<typeof AuditSearch>;

/** The filter without its empty entries (an emptied box is no filter); anything that does not fit is dropped. */
export function compactAuditSearch(next: AuditSearch): AuditSearch {
  const present = Object.fromEntries(Object.entries(next).filter(([, v]) => v !== undefined && v !== ''));
  return AuditSearch.safeParse(present).data ?? {};
}
